module.exports = __webpack_public_path__ + "media/images/img_voice1-7a752b431cd44881916b0caa4545d6d3.jpg";